export const saveToLocaleStorage = (key: TLocalStorageKeys, value: string) => {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    console.log('saveToLocaleStorage error', e);
  }
};
